import GlassCard from '@/components/GlassCard';
import { Subtitle, Text } from '@/components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProgressCardProps {
    progressPercentage?: number;
}

const ProgressCard: React.FC<ProgressCardProps> = ({
    progressPercentage = 0
}) => {
    const { t } = useTranslation();

    return (
        <GlassCard className="flex flex-col justify-between p-5">
            <div className="mb-4 flex items-start justify-between">
                <div>
                    <Subtitle as="h2" className="text-base dark:text-white">
                        {t('course.yourProgress')}
                    </Subtitle>
                    <Text size="sm" muted className="mt-0.5 dark:text-neutral-400">
                        {t('course.continueWhereYouLeftOff')}
                    </Text>
                </div>
                <div className="text-right">
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {progressPercentage}%
                    </div>
                    <Text as="div" size="xs" muted className="dark:text-neutral-400">
                        {t('course.completed')}
                    </Text>
                </div>
            </div>

            <div className="h-2 w-full rounded-full bg-gray-200 dark:bg-neutral-700">
                <div
                    className="h-2 rounded-full transition-all duration-500"
                    style={{ width: `${progressPercentage}%`, backgroundColor: 'var(--color-theme-primary)' }}
                />
            </div>
        </GlassCard>
    );
};

export default ProgressCard;
